export type MarketingGame = {
  id: string;
  label: string;
  keywords: string[];
};

export const ALL_GAMES_FILTER = "all";

export const GENERAL_GAME_ID = "general";

/** Display order for game filter chips */
export const MARKETING_GAMES: MarketingGame[] = [
  { id: "arrowsong", label: "Arrowsong", keywords: ["arrowsong"] },
  {
    id: "arrowsong-DarkOmen",
    label: "Arrowsong: Dark Omen",
    keywords: ["arrowsong_darkomen", "darkomen", "dark_omen"],
  },
  {
    id: "cookd-up",
    label: "Cook'd Up",
    keywords: ["cookdup", "cook'd", "cook_d-up", "cook_d up"],
  },
  {
    id: "cops-vs-robbers",
    label: "Cops vs Robbers",
    keywords: ["copsvsrobbers", "cops vs robbers"],
  },
  {
    id: "cyber-shock",
    label: "Cyber Shock",
    keywords: ["cybershock", "cyber shock"],
  },
  {
    id: "dead-ahead",
    label: "Dead Ahead",
    keywords: ["deadahead", "dead ahead"],
  },
  {
    id: "espionage-express",
    label: "Espionage Express",
    keywords: ["espionage", "espionnage", "expionage"],
  },
  {
    id: "monkey-madness",
    label: "Monkey Madness",
    keywords: [
      "monkeymadness",
      "monkey madness",
      "monkey_madness",
      "moneymadness",
    ],
  },
  {
    id: "plush-rush",
    label: "Plush Rush",
    keywords: ["plushrush", "plush rush", "prscreenshot"],
  },
  {
    id: "quantum-arena",
    label: "Quantum Arena",
    keywords: ["quantumarena", "quantum arena"],
  },
  {
    id: "terminator-uprising",
    label: "Terminator Uprising",
    keywords: ["terminator", "t800", "centurion"],
  },
  { id: "versus", label: "Versus", keywords: ["versus"] },
  { id: "wayfinders", label: "Wayfinders", keywords: ["wayfinders"] },
  {
    id: "wizard-academy",
    label: "Wizard Academy",
    keywords: ["wizardacademy", "wizardgame", "wizard academy"],
  },
  {
    id: "Trials Of Atlantis",
    label: "Trials Of Atlantis",
    keywords: ["toa"],
  },
];

/**
 * Force specific assets to a game regardless of keyword matching.
 * Keys are paths relative to the CDN root (e.g. Images/Games/...).
 */
export const GAME_OVERRIDES: Record<string, string> = {
  "Images/Games/Characters/WaitingRoomCharacters.png": GENERAL_GAME_ID,
};

/** Paths that are always treated as brand/general assets */
export const GENERAL_PATH_PREFIXES = [
  "Images/Actors/",
  "Images/Logo/",
  "Videos/Promo Videos/",
  "Videos/Update Videos/",
];

export const CATEGORY_ORDER = [
  "Trailers",
  "Promo Videos",
  "Characters",
  "Game Art",
  "Game Titles",
  "Game screenshots",
  "Posters",
  "Actors",
  "Logo",
  "Update Videos",
  "Other",
];
